"use client";

import { RegisterForm } from "@/components/register-form";

export default function Page() {
  return (
    <div className="flex min-h-svh w-full items-start justify-center px-4 py-6 sm:px-6 md:items-center md:p-10">
      <div className="w-full max-w-lg">
        <RegisterForm />
      </div>
    </div>
  );
}
